import { html } from 'lit';
import type { Subscription } from '@common/types/model.d.js';
import { formatMsisdn } from '@common/utils/MobilePhoneNumber.js';
import type { TefComs4p } from '@src/components/TefComs4p.js';

//
// renders a single subscription block in EDIT mode
//
// {subscription msisdn}
//   {app consent BLOCK}
//
export const singleSubscriptionIdentifierBoundEdit = function render(this: TefComs4p, subscription : Subscription) {
  return html`
    <div class="container container--size-full container--prio-bg-3">
      <h6 class="u-sy--tight" style="padding: 10px 0">${formatMsisdn(subscription.msisdn)}</h6>
    </div>
    <div class="container u-sy--tight">
      ${subscription.apps.map((app) => this.getTemplateFn('singleAppConsentEdit')(app))}
      <div class="row">
        <a class="button button-tag button-tag--size-small" @click="${() => { this.revokeAllAppConsentsForSubscription(subscription); }}">
          Alle deaktivieren
        </a>
      </div>
    </div>
  `;
};
